import './StudentInvited.scss';
import PinExtension from '../ReadingAnalysisPinCE/puzzle-averpoint.gif';

export default function StudentInvitedReadingAnalysisPin({ onContinue }) {
  return (
    <div className="student-invited-about-us">
      <div className="shell">
        <div className="step-eyebrow">Step 4 of 4</div>
        <h1 className="step-h1">Configure your browser extension.</h1>

        <ul className="ext-list">
          <li>Click the puzzle piece</li>
          <li>Click the pin icon</li>
          <li>
            Confirm the icon is blue, meaning you're logged in. If it's white,
            click the icon and log in.
          </li>
        </ul>

        <div className="mt-5 text-center">
          <img src={PinExtension} className="w-100" alt="pin extension" />
        </div>

        <button type="button" className="btn-primary" onClick={onContinue}>
          Continue
        </button>
      </div>
    </div>
  );
}
